var $625df06cecc70764$exports = {};
$625df06cecc70764$exports = {
    "breadcrumbs": `\u{41D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{44F}`
};


export {$625df06cecc70764$exports as default};
//# sourceMappingURL=ru-RU.module.js.map
